import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { MainAppComponent } from '../../../layout/layout.component';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';

@Component({
    selector: 'addeditrole',
    templateUrl: './addrole.component.html',
    styleUrls: ['./addrole.component.scss']
})

export class AddEditRole implements OnInit {
    isSubmitted: boolean = false;
    MenuItems = [];
    constructor(public _router: Router,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute,
        private _mApp: MainAppComponent,
        private _toastrService: ToastrService) {


    }
    ngOnInit() {
        let id = this._route.snapshot.params['id'];
        if (id != 0 && id != null && id != undefined) {
            this.GetListOfAppPrivileges(id);
        }
    }

    GetListOfAppPrivileges(id) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetListOfAppPrivileges + id)
            .subscribe(
                data => {
                    this.MenuItems = data.json().Result;
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    onSubmit() {
        this._mApp.ShowLoader();
        if (this.MenuItems != null) {
            this._http.post(this._appUrl.UpsertAppPrivileges, this.MenuItems)
                .subscribe(
                    data => {
                        this._mApp.HideLoader();
                        this._toastrService.success(data.json().Result, '');
                        this._router.navigate(['/rolelist']);
                    },
                    error => {
                        this._mApp.HideLoader();
                        this._toastrService.error(error.json().Result, '');
                    }
                );
        }
        else {
            this._toastrService.error("No data found", '');
        }
    }

}
